var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5 3 C 3.35 3 2 4.35 2 6 L 2 17 C 2 17.55 2.45 18 3 18 L 4.0507812 18 C 4.2958204 19.692046 5.7411114 21 7.5 21 C 9.2588886 21 10.70418 19.692046 10.949219 18 L 13.050781 18 C 13.29582 19.692046 14.741111 21 16.5 21 C 18.258889 21 19.70418 19.692046 19.949219 18 L 21 18 C 21.55 18 22 17.55 22 17 L 22 11.740234 C 22 11.020234 21.739297 10.329063 21.279297 9.7890625 L 16.359375 4.0507812 C 15.789375 3.3807813 14.960078 3 14.080078 3 L 5 3 z M 12 5 L 14.080078 5 C 14.370078 5 14.649844 5.1296094 14.839844 5.3496094 L 19.679688 11 L 12 11 L 12 5 z M 7.5 16 C 8.327 16 9 16.673 9 17.5 C 9 18.327 8.327 19 7.5 19 C 6.673 19 6 18.327 6 17.5 C 6 16.673 6.673 16 7.5 16 z M 16.5 16 C 17.327 16 18 16.673 18 17.5 C 18 18.327 17.327 19 16.5 19 C 15.673 19 15 18.327 15 17.5 C 15 16.673 15.673 16 16.5 16 z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.b235997414bd55a3d744725b152567e8.svg";
export { ForwardRef as ReactComponent };